// extracted by mini-css-extract-plugin
export default {"section":"Main6_section__2XhJq","sectionContent":"Main6_sectionContent__Xkjld","title":"Main6_title__YdIhw","description":"Main6_description__+Xs7R","article":"Main6_article__6DZFs"};